
import { defineComponent } from 'vue';
import { AppFormRow, AppCard, AppButton, AppSwitch, AppSelect, AppFileUpload, AppAvatarBreadcrumb } from '@/components';
import { useAvatarImageAdd } from '@/modules/avatar/item/image/model/add';
import { ROUTE_NAME_AVATAR } from '@/modules/avatar/router';

export default defineComponent({
    name: ROUTE_NAME_AVATAR.ITEM.IMAGE.ADD,
    components: { AppFormRow, AppCard, AppButton, AppSwitch, AppSelect, AppFileUpload, AppAvatarBreadcrumb },
    setup() {
        const { model, colorOption, layerOption, create } = useAvatarImageAdd();

        return { model, colorOption, layerOption, create };
    }
});
